import { DocumentData } from "@angular/fire/firestore";
import * as moment from "moment-timezone";

export class HoursOfOperation {
  begin: number;
  end: number;
  constructor() {
    this._default();
  }
  private _default() {
    this.begin = 240;
    this.end = 1680;
  }
  public set(range: number[]) {
    this.begin = range[0];
    this.end = range[1];
    return this;
  }

  public toJSON = () => ({ begin: this.begin, end: this.end });
  public load(data: DocumentData) {
    this.begin = data.begin;
    this.end = data.end;
    return this;
  }
  public edit(hours: HoursOfOperation) {
    this.begin = hours.begin;
    this.end = hours.end;
    return this;
  }
  private get beginTime(): string {
    return moment()
      .startOf("day")
      .add(this.begin, "minutes")
      .format("LT");
  }

  private get endTime(): string {
    return moment()
      .startOf("day")
      .add(this.end, "minutes")
      .format("LT");
  }

  public toString(): string {
    return this.beginTime + " - " + this.endTime;
  }
}
